// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e61b70ba","453":"7a34e51f"}[chunkId] + ".chunk.js";
};